import './LocaleSelector.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Dropdown } from 'react-bootstrap';
import flagIta from '../assets/flag_ita.png';
import flagEng from '../assets/flag_eng.png';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

type ToggleProps = {
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}
type Ref = HTMLButtonElement;

const CustomToggle = React.forwardRef<Ref, ToggleProps>(({ children, onClick }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className="locale-selector-toggle"
    >
      {children}
    </button>
  )
});

export default function LocaleSelector() {
  const { i18n } = useTranslation();

  const changeLocale = (locale: 'en' | 'it') => () => {
    i18n.changeLanguage(locale);
  }

  return (
    <Dropdown className="locale-selector">
      <Dropdown.Toggle as={CustomToggle}>
        <FontAwesomeIcon size="lg" icon={solid('language')} />
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        <Dropdown.Item onClick={changeLocale('it')} className={classNames({ selected: i18n.language === 'it' })}>
          <img src={flagIta} alt="Italian localization" className="locale-flag" />
          <span className="ms-3">Italian</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={changeLocale('en')} className={classNames({ selected: i18n.language === 'en' })}>
          <img src={flagEng} alt="English localization" className="locale-flag" />
          <span className="ms-3">English</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}